import React, { useEffect, useState } from 'react'
import { Button, Divider, Modal, Switch, Input, Space } from 'antd'
import { updateApplicationItem } from '../../../services/application-items'
import { APP_STATUS_DELIVERY, APP_STATUS_PAY } from '../../reports/constants'
import { formatDecimalAmount } from '../../../utils/number-utils'

const ApproveModal = ({ application, showModal, onChancel, onAgree, onReject, isLoading, isOnlyReject }) => {
  const [activeApplication, setActiveApplication] = useState(null)
  const [isStateLoading, setIsStateLoading] = useState(false)
  const [stateWaChanged, setStateWaChanged] = useState(false)

  useEffect(() => {
    setActiveApplication(application)
  }, [application])

  const onCommentChange = (id) => (e) => {
    const newApplication = JSON.parse(JSON.stringify(activeApplication))
    if (newApplication?.application_items[id]) {
      newApplication.application_items[id].approved_comment = e.target.value
    }
    setActiveApplication(newApplication)
  }

  const onCommentUpdate = (id) => () => {
    setIsStateLoading(true)
    const applicationItemId = activeApplication?.application_items[id].id
    const data = {
      data: {
        approved_comment: activeApplication?.application_items[id].approved_comment,
      },
    }
    setStateWaChanged(true)
    updateApplicationItem(applicationItemId, data)
      .catch(() => {
        // TODO: error handling
      })
      .finally(() => setIsStateLoading(false))
  }

  const updateApplicationStatus = (id) => (newStatus) => {
    setIsStateLoading(true)
    const newApplication = JSON.parse(JSON.stringify(activeApplication))
    if (newApplication?.application_items[id]) {
      newApplication.application_items[id].approved = newStatus
    }
    setActiveApplication(newApplication)
    setStateWaChanged(true)
    const applicationItemId = newApplication?.application_items[id].id
    const data = {
      data: {
        approved: newStatus,
      },
    }
    updateApplicationItem(applicationItemId, data)
      .catch(() => {
        // TODO: error handling
      })
      .finally(() => setIsStateLoading(false))
  }

  const onAgreeHandler = () => {
    const payment_type = activeApplication?.implementation?.payment_type
    const state = payment_type === 'cashless' ? APP_STATUS_PAY : APP_STATUS_DELIVERY
    onAgree(activeApplication.id, state)()
    onChancel(stateWaChanged)
  }

  const onRejectHandler = () => {
    onReject(activeApplication.id, 'reject')
    onChancel(stateWaChanged)
  }

  const onCancelHandler = () => {
    onChancel(stateWaChanged)
  }

  return (
    <Modal
      title="Позиции для согласования"
      visible={showModal}
      onCancel={onCancelHandler}
      footer={[
        <Button key="back" onClick={onCancelHandler} disabled={isLoading}>
          Отмена
        </Button>,
        <Button key="return" type="danger" onClick={onRejectHandler} disabled={isLoading}>
          На доработку
        </Button>,
        <Button key="agree" type="primary" onClick={onAgreeHandler} disabled={isLoading || isOnlyReject}>
          Согласовать
        </Button>,
      ]}
    >
      {activeApplication?.implementation?.implementation_items &&
        activeApplication?.implementation?.implementation_items.map((item, id) => {
          return (
            <div>
              <span>Снабжение: </span>
              <span>{`${item.name || '-'}, ${formatDecimalAmount(item.amount) || '-'} ${item.unit || ''}, Цена: ${
                item.price || '-'
              }, Поставщик: ${item.provider || '-'}`}</span>
              {!isOnlyReject && (
                <div style={{ paddingTop: 10 }}>
                  <span>Статус: </span>
                  <Switch
                    checked={activeApplication?.application_items[id]?.approved}
                    onChange={updateApplicationStatus(id)}
                    loading={isStateLoading}
                  />
                </div>
              )}
              {!isOnlyReject && (
                <div style={{ paddingTop: 10 }}>
                  <span>Комментарий: </span>
                  <Space>
                    <Input
                      allowClear
                      value={activeApplication?.application_items[id]?.approved_comment}
                      onChange={onCommentChange(id)}
                    />
                    <Button disabled={isStateLoading} onClick={onCommentUpdate(id)}>
                      Сохранить
                    </Button>
                  </Space>
                </div>
              )}
              <Divider />
            </div>
          )
        })}
    </Modal>
  )
}

export default ApproveModal
